import React from 'react';
import { styled } from 'baseui';
import ErrorMessage from '../error-message';
const ErrorMsgDiv = styled('div', {
  width: '100%',
  height: '100%',
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  top: 0
});
type PropT = {
  errorMessage?: string;
  onRetry?: () => void;
  buttonText?: string;
  isModernizedPlayer?: boolean;
};
const MediaError = ({
  errorMessage,
  onRetry,
  buttonText
}: PropT) => {
  return <ErrorMsgDiv data-testid="errDiv">
      <ErrorMessage errorMessage={errorMessage} onRetry={onRetry} buttonText={buttonText} />
    </ErrorMsgDiv>;
};
export default MediaError;